import "./form";
import { GVQuery, GVResult } from "./model";
import "./comm";
import { GVServerComm } from "./comm";
import {
  GVAutocomplete,
  GVDatepicker,
  GVRangeSlider,
  GVValueSlider,
} from "./form";
import { GVMessageTable } from "./intl";
import "bootstrap";
import "./style/goedkoop.less";
import "./style/results.less";
import "./style/mask.css";
import { GVResultView } from "./views";
import { GVFilterManager } from "./filter";
import { SetFilterUI } from "./filterui";
import { GVPager } from "./pager";
import { gaEvent, gaSend } from "./analytics";

class GVMainPage {
  constructor() {
    this.roundtrip = true;
    this.resultPageShown = false;
    this.filterMgr = new GVFilterManager();

    this.initCommunication();
    this.loadTemplates();
    this.initPageElements();
    this.initSearchForm();
    this.initDestinationLinks();
    this.initDateLinks();

    this.resetSearch();

    this.resumeSearch();
  }

  initCommunication() {
    this.comm = new GVServerComm();
    this.comm.onAsyncError = (e, i) => this.onAsyncError(e, i);
    this.comm.onAsyncWarning = (e, i) => this.onAsyncWarning(e, i);
    this.comm.onSessionCreated = (sid) => this.onSessionCreated(sid);
    this.comm.onEngineStarted = () => this.onEngineStarted();
    this.comm.onProgressUpdate = () => this.onProgressUpdate();
    this.comm.onResultsUpdate = () => this.onResultsUpdate();
    this.comm.onEngineDone = () => this.onEngineDone();
  }

  loadTemplates() {
    this.resultPageTemplate = require("./views/resultpage.handlebars");
    this.resultListTemplate = require("./views/resultlist.handlebars");
    this.providerListTemplate = require("./views/providerlist.handlebars");
    this.progressTemplate = require("./views/progress.handlebars");
    this.suggestionsTemplate = require("./views/suggestions.handlebars");
  }

  initPageElements() {
    this.modal = $("#gv_modal");
    this.modalTitle = $("#gv_modal_title");
    this.modalBody = $("#gv_modal_body");
    this.content = $("#content");
    this.messageBox = $("#messageBox");
    this.progressBox = $("#progress");
    this.baseContent = this.content.html();
  }

  initDestinationLinks() {
    $(".destination-link").each((i, e) => {
      e = $(e);
      e.click((ev) => this.onDestinationLinkClicked(e.data("name")));
    });
  }

  initDateLinks() {
    document.querySelectorAll(".date-link").forEach((e) => {
      e.addEventListener("click", () => {
        this.departureDate.value = new Date(e.dataset.depart);
        this.returnDate.value = new Date(e.dataset.return);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });
    });
  }

  initSearchForm() {
    const ac_url = "https://api.goedkoopstevliegtickets.nl/autocomplete/";

    /* Create form elements */
    this.originField = new GVAutocomplete($("#gv_search_origin"), ac_url);
    let destination =
      typeof pageDestination === "undefined" ? null : pageDestination;
    this.destinationField = new GVAutocomplete(
      $("#gv_search_dest"),
      ac_url,
      null,
      destination
    );
    this.altOriginField = new GVAutocomplete(
      $("#gv_search_alt_origin"),
      ac_url
    );
    this.altDestField = new GVAutocomplete($("#gv_search_alt_dest"), ac_url);
    this.roundtripField = document.getElementById("roundtrip");
    this.onewayField = document.getElementById("oneway");
    this.adultsField = document.getElementById("adults");
    this.childrenField = document.getElementById("children");
    this.infantsField = document.getElementById("infants");
    this.searchBox = $("#searchBox");
    this.searchButton = $("#search-button");
    this.departureDate = new GVDatepicker(
      $("#departureDate"),
      new Date().addDays(14)
    );
    this.returnDate = new GVDatepicker(
      $("#returnDate"),
      new Date().addDays(21)
    );

    /* Install event handlers */
    this.roundtripField.onchange = () => this.onRoundtripChange();
    this.onewayField.onchange = () => this.onRoundtripChange();
    this.departureDate.onChange = () => this.onDepartureDateChange();
    this.returnDate.onChange = () => this.onReturnDateChange();
    this.searchButton.click((e) => this.onSubmit(e));

    $(window).on("popstate", (e) => this.onPopState(e));
  }

  devalidateForm() {
    this.originField.devalidate();
    this.destinationField.devalidate();
    this.departureDate.devalidate();
    this.returnDate.devalidate();
  }

  validateForm() {
    var valid = true;
    this.devalidateForm();
    if (!this.originField.value) valid = this.originField.valid = false;
    if (!this.destinationField.value)
      valid = this.destinationField.valid = false;
    return valid;
  }

  onRoundtripChange() {
    this.setRoundtripFormEnabled(this.roundtripField.checked);
  }

  onDepartureDateChange() {
    let minDate = this.departureDate.value;
    this.returnDate.minimum = minDate;
    if (minDate > this.returnDate.value) {
      this.returnDate.value = minDate;
    }
  }

  onReturnDateChange() {}

  onDestinationLinkClicked(dest) {
    this.destinationField.value = dest;
    console.log(dest);
    window.scrollTo(0, 0);
  }

  onSubmit(event) {
    event.preventDefault();

    if (!this.validateForm()) return;

    let query = new GVQuery();
    query.origin = this.originField.value;
    query.destination = this.destinationField.value;
    query.alt_origin = this.altOriginField.value;
    query.alt_destination = this.altDestField.value;
    query.departureDate = this.departureDate.value.toInputDateValue();
    query.returnDate = this.returnDate.value.toInputDateValue();
    this.roundtrip = query.roundtrip = this.roundtripField.checked;

    query.adults = this.adultsField.value;
    query.children = this.childrenField.value;
    query.infants = this.infantsField.value;

    this.filterMgr.initialize(query.destination, query.roundtrip);
    this.filterMgr.onFiltersChanged = () => this.onFiltersChanged();

    try {
      this.comm.createSession(query);
    } catch (e) {
      this.onAsyncError(e, null);
    }
    gaEvent("zoeken start", query.createGaEventCode());
    this.showProgress(this.progressTemplate({ starting: true }));
  }

  onSessionCreated(sid) {
    console.log(`session created`);
    this.searchButton.prop("disabled", true);
    const dest = this.comm.currentQuery.destination;
    const str =
      "?dest=" +
      encodeURI(dest) +
      "&sid=" +
      encodeURI(sid) +
      "&rt=" +
      this.comm.currentQuery.roundtrip;
    window.history.pushState(
      null,
      "Goedkoopste Vliegtickets naar " + dest,
      str
    );
  }

  onAsyncError(error, info) {
    console.log(`error: ${error} with info:`, info);
    this.resetSearch();

    switch (error) {
      //TODO: case "gv_inv_adults:":
      //this.adultsField.valid = false;
      case "gv_bad_origin":
        this.showSuggestionsDialog(
          GVMessageTable[error],
          info["suggestions"],
          this.originField
        );
      case "gv_no_origin":
        this.originField.valid = false;
        break;
      case "gv_bad_dest":
        this.showSuggestionsDialog(
          GVMessageTable[error],
          info["suggestions"],
          this.destinationField
        );
      case "gv_no_dest":
        this.destinationField.valid = false;
        break;
      default:
        this.showModal(
          GVMessageTable["gv_error_modal_title"],
          GVMessageTable[error]
        );
    }
    this.hideProgress();
  }

  showSuggestionsDialog(msg, sugg, input) {
    const suggBody = this.suggestionsTemplate({ suggestions: sugg });
    console.log(suggBody, sugg);
    this.showModal(msg, suggBody);
    const that = this;
    $(".sugg_link").on("click", function () {
      const el = $(this);
      input.value = el.html();
      console.log("clicked select for " + el.html());
      that.modal.modal("hide");
    });
  }

  onAsyncWarning(error, info) {
    console.error(info.cause);
    console.log(`warning: ${error} with info:`, info);
    this.showMessage(GVMessageTable[error]);
  }

  onEngineDone() {
    console.log(`engine done`);
    this.hideProgress();
    this.resetSearch();
  }

  onEngineStarted() {
    console.log(`engine started`);
    this.showResultPage();
  }

  onProgressUpdate() {
    console.log(`progress update`);
    const pct = this.comm.progress * 100;
    if (pct !== 100)
      this.showProgress(this.progressTemplate({ percentage: pct }));
  }

  hideResultPage() {
    if (!this.resultPageShown) return;
    this.resultPageShown = false;
    this.content.html(this.baseContent);
  }

  showResultPage() {
    if (this.resultPageShown) return;
    this.resultPageShown = true;
    this.content.html(this.resultPageTemplate());
    this.filterContainer = $("#gv_filter_container");
    this.flexContainer = $("#gv_flex_container");
    this.resultContainer = $("#gv_result_container");
    this.backButton = $("#gv_back_btn");
    this.filterButton = $("#gv_filter_btn");
    this.backButtonDiv = $("#gv_back_btn_div");
    this.filterButtonDiv = $("#gv_filter_btn_div");
    this.stopFilterUI = new SetFilterUI(
      $("#gv_stop_filter"),
      "Overstappen",
      new Set(["0", "1", "2"]),
      true
    );
    this.originFilterUI = new SetFilterUI(
      $("#gv_origin_filter"),
      "Vertrekplaats"
    );
    this.destinationFilterUI = new SetFilterUI(
      $("#gv_dest_filter"),
      "Bestemming"
    );
    this.stopFilterUI.onChange = () => this.onFiltersInteracted();
    this.originFilterUI.onChange = () => this.onFiltersInteracted();
    this.destinationFilterUI.onChange = () => this.onFiltersInteracted();
    this.outboundDepartureSlider = new GVRangeSlider(
      $("#gv_out_depart_slider")
    );
    this.outboundDepartureSlider.onChange = () => this.onFiltersInteracted();
    if (this.roundtrip) {
      this.inboundDepartureSlider = new GVRangeSlider(
        $("#gv_in_depart_slider")
      );
      this.inboundDepartureSlider.onChange = () => this.onFiltersInteracted();
    }
    this.providerModal = $("#offererSelectionModal");
    this.durationSlider = new GVValueSlider($("#gv_dur_slider"));
    this.durationSlider.onChange = () => this.onFiltersInteracted();
    this.sortMethod = "price";
    this.resultPager = new GVPager(this.resultContainer, (r) =>
      this.resultListTemplate({
        results: r,
        numShown: this.shownResults.length,
        numTotal: this.results.length,
        badFilter: this.shownResults.length === 0 && this.results.length !== 0,
      })
    );
    this.resultPager.onRender = () => this.onResultsRendered();
    this.backButton.on("click", () => this.setSearchBoxVisible(true));
    this.filterButton.on("click", () =>
      this.setFilterBoxVisible(!this.filtersVisible)
    );
    this.setSearchBoxVisible(false);
    this.setFilterBoxVisible(false);
    this.stopFilterUI.addPrettyNames({
      0: "Nonstop",
      1: "1 stop",
      2: "2+ stops",
    });
  }

  renderResults(causedByFilterSetting) {
    const that = this;
    const sortFuncs = {
      price: GVResult.comparePrice,
      stops: GVResult.compareStops,
      duration: GVResult.compareDuration,
    };
    this.shownResults.sort(sortFuncs[this.sortMethod]);
    let rs = this.shownResults.map(
      (e) =>
        new GVResultView(
          e,
          this.comm.airportLookup,
          this.comm.airlineLookup,
          this.comm.providerLookup
        )
    );
    this.resultPager.update(rs);
    if (causedByFilterSetting) this.resultPager.goto(0); //TODO: Integrate with update to prevent needless rerender
    this.sortMethodSelect = $("#sort-mode");
    that.sortMethodSelect.val(that.sortMethod);
    this.sortMethodSelect.on("change", function () {
      that.sortMethod = that.sortMethodSelect.val();
      that.renderResults(true);
    });
  }

  onResultsRendered() {
    const that = this;
    $("#clearfilter_nores").on("click", function () {
      that.clearFilters();
    });
    $(".offers-mobile-link, .offer-button").on("click", (e) => {
      const unique = e.target.closest(".result").dataset["unique"];
      that.onSelectResult(unique);
    });
    $(".gv_full_details").addClass("d-none");
    $(".result").each(function () {
      const result = $(this);
      const flightDetails = result.find(".flight-details:not(.non-stop)");
      result.find(".trips-toggle").on("click", function () {
        const summary = flightDetails.find(".gv_summary");
        const full = flightDetails.find(".gv_full_details");
        if (summary.hasClass("d-none")) {
          summary.removeClass("d-none");
          full.addClass("d-none");
        } else {
          summary.addClass("d-none");
          full.removeClass("d-none");
        }
      });
      flightDetails.on("click", function () {
        const el = flightDetails;
        const summary = el.find(".gv_summary");
        const full = el.find(".gv_full_details");
        if (summary.hasClass("d-none")) {
          summary.removeClass("d-none");
          full.addClass("d-none");
        } else {
          summary.addClass("d-none");
          full.removeClass("d-none");
        }
      });
    });
    $(".doorklik").on("click", (e) => {
      e.preventDefault();
      const target = e.target;
      const unique = target.closest(".result").dataset["unique"];
      this.trackClickThrough(unique, target.dataset["offer"]);
      window.open(target.getAttribute("href"), "_blank");
    });
  }

  trackClickThrough(uniek, offer) {
    const result = this.comm.results[uniek];
    const action = `${result.origin}-${result.destination}`;
    gaEvent("doorklik", action, offer);
  }

  onSelectResult(unique) {
    const result = this.comm.results[unique];
    if (result.offers.length === 1) {
      this.trackClickThrough(unique, result.offers[0].code);
      window.open(result.offers[0].url, "_blank");
    } else {
      this.openProviderModal(result);
    }
  }

  /**
   *
   * @param {GVResult} result
   */
  openProviderModal(result) {
    const view = new GVResultView(
      result,
      this.comm.airportLookup,
      this.comm.airlineLookup,
      this.comm.providerLookup
    );
    const html = this.providerListTemplate(view);
    this.providerModal.html(html);
    this.providerModal.modal();
    this.providerModal.find(".doorklik").click((e) => {
      e.preventDefault();
      const doorklik = e.target.closest(".doorklik");
      const offerersList = e.target.closest("#offerersList");
      this.trackClickThrough(
        offerersList.dataset["uniek"],
        doorklik.dataset["offer"]
      );
      window.open(doorklik.getAttribute("href"), "_blank");
    });
  }

  filterResults() {
    let rs = [];
    for (let r in this.comm.results) {
      rs.push(this.comm.results[r]);
    }
    this.results = rs;
    this.shownResults = this.filterMgr.applyFilters(rs);
  }

  onResultsUpdate() {
    console.log(`results update`);
    this.filterResults();
    this.renderResults(false);
    this.filterMgr.updateLimits(this.results);
    this.originFilterUI.addPrettyNames(this.comm.airportLookup);
    this.destinationFilterUI.addPrettyNames(this.comm.airportLookup);
    this.onFiltersChanged();
  }

  onFiltersChanged() {
    const durationMax = this.filterMgr.currentFilter.durationMax;
    this.originFilterUI.setValues(
      this.filterMgr.currentFilter.knownOrigins,
      this.filterMgr.currentFilter.excludedOrigins
    );
    this.destinationFilterUI.setValues(
      this.filterMgr.currentFilter.knownDestinations,
      this.filterMgr.currentFilter.excludedDestinations
    );
    const onChangeHandlr = this.durationSlider.onChange;
    this.durationSlider.onChange = function () {};
    this.durationSlider.maxValue = this.filterMgr.currentFilter.durationLimit;
    this.durationSlider.value = durationMax;
    this.durationSlider.onChange = onChangeHandlr;
    this.filterResults();
    this.renderResults(false);
  }

  onFiltersInteracted() {
    console.log(`filter settings update`);
    this.filterMgr.currentFilter.excludedOrigins = this.originFilterUI.selectedOptions;
    this.filterMgr.currentFilter.excludedDestinations = this.destinationFilterUI.selectedOptions;
    this.filterMgr.currentFilter.excludedStops = this.stopFilterUI.selectedOptions;
    this.filterMgr.currentFilter.departureMin = this.outboundDepartureSlider.valueLeft;
    this.filterMgr.currentFilter.departureMax = this.outboundDepartureSlider.valueRight;
    if (this.roundtrip) {
      this.filterMgr.currentFilter.returnMin = this.inboundDepartureSlider.valueLeft;
      this.filterMgr.currentFilter.returnMax = this.inboundDepartureSlider.valueRight;
    }
    this.filterMgr.currentFilter.durationMax = this.durationSlider.value;
    console.log(this.filterMgr.currentFilter.excludedStops);
    this.filterMgr.updateFilters();
    this.filterResults();
    this.renderResults(true);
  }

  clearFilters() {
    this.filterMgr.currentFilter.clear();
    this.onFiltersChanged();
  }

  setRoundtripFormEnabled(v) {
    if (v) $(".gv_oneway_toggle").show();
    else $(".gv_oneway_toggle").hide();
  }

  setSearchBoxVisible(v) {
    if (v) {
      this.searchBox.addClass("d-block");
      this.searchBox.removeClass("d-none");
    } else {
      this.searchBox.removeClass("d-block");
      this.searchBox.addClass("d-none");
    }
  }

  setFilterBoxVisible(v) {
    this.filtersVisible = v;
    if (v) {
      this.filterButton.html("Filters verbergen");
      this.filterContainer.addClass("d-block");
      this.filterContainer.removeClass("d-none");
      this.backButtonDiv.removeClass("col-6");
      this.backButtonDiv.addClass("d-none");
      this.filterButtonDiv.removeClass("col-6");
      this.filterButtonDiv.addClass("col-12");
    } else {
      this.filterButton.html("Filters aanpassen");
      this.backButtonDiv.removeClass("d-none");
      this.backButtonDiv.addClass("col-6");
      this.filterContainer.removeClass("d-block");
      this.filterContainer.addClass("d-none");
      this.filterButtonDiv.removeClass("col-12");
      this.filterButtonDiv.addClass("col-6");
    }
  }

  resetSearch() {
    this.comm.resetState();
    this.searchButton.prop("disabled", false);
    this.hideProgress();
  }

  showMessage(message) {
    this.messageBox.html(message);
    this.messageBox.show();
  }

  hideMessage() {
    this.messageBox.hide();
  }

  showProgress(message) {
    this.progressBox.html(message);
    this.progressBox.show();
  }

  hideProgress() {
    this.progressBox.hide();
  }

  showModal(title, body) {
    this.modalTitle.html(title);
    this.modalBody.html(body);
    this.modal.modal();
  }

  queryDecode(querystring) {
    // remove any preceding url and split
    querystring = querystring
      .substring(querystring.indexOf("?") + 1)
      .split("&");
    var params = {},
      pair,
      d = decodeURIComponent;
    // march and parse
    for (var i = querystring.length - 1; i >= 0; i--) {
      pair = querystring[i].split("=");
      params[d(pair[0])] = d(pair[1] || "");
    }

    return params;
  }

  handleQueryURL(url) {
    //TODO: Validate SID
    const el = this.queryDecode(window.location.search);
    const dest = el["dest"];
    const rt = el["rt"] === "true";
    const sid = el["sid"];
    if (!dest) return false;
    this.comm.resumeSession(sid);
    this.showResultPage();
    this.filterMgr.initialize(dest, rt);
    this.filterMgr.onFiltersChanged = () => this.onFiltersChanged();
    this.destinationField.value = dest;
    return true;
  }

  onPopState(e) {
    console.log("popstate", e, window.location);
    if (!this.handleQueryURL(window.location)) {
      this.resetSearch();
      this.hideResultPage();
    }
  }

  resumeSearch() {
    this.handleQueryURL(window.location);
  }
}

function init() {
  window.mainPage = new GVMainPage();
}

$(document).ready(init);
